import api from './axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const getMemberKpis = (userId) =>
  api.get(`/users/${userId}/kpis`).then((r) => r.data);

export const createMemberKpi = (userId, payload) =>
  api.post(`/users/${userId}/kpis`, payload).then((r) => r.data);

export const updateMemberKpi = (userId, kpiId, payload) =>
  api.put(`/users/${userId}/kpis/${kpiId}`, payload).then((r) => r.data);

export const deleteMemberKpi = (userId, kpiId) =>
  api.delete(`/users/${userId}/kpis/${kpiId}`).then((r) => r.data);

export const useMemberKpis = (userId) =>
  useQuery({
    queryKey: ['member-kpis', userId],
    queryFn: () => getMemberKpis(userId),
    enabled: !!userId,
    staleTime: 30_000,
  });

export const useMemberKpiMutations = (userId) => {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: ['member-kpis', userId] });

  const create = useMutation({
    mutationFn: (payload) => createMemberKpi(userId, payload),
    onSuccess: invalidate,
  });
  const update = useMutation({
    mutationFn: ({ kpiId, payload }) => updateMemberKpi(userId, kpiId, payload),
    onSuccess: invalidate,
  });
  const remove = useMutation({
    mutationFn: (kpiId) => deleteMemberKpi(userId, kpiId),
    onSuccess: invalidate,
  });

  return { create, update, remove };
};
